import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=05f0e395&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=05f0e395&lang=scss&scoped=true&"
import style1 from "./FilePreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0e395",
  null
  
)

export default component.exports